module.exports = __webpack_public_path__ + "img/cliente_bravo.88ac3b98.jpg";